import Login from '../user/Login';
export default {
    Login: {
        component: Login,
        path: '/'
    },
};